<template>
  <div>
    <div ref="HeadSection" class="HeadSection pt-16 pb-0">
          <v-container class="hero-section">
            <v-row>
              <v-col lg="12" >
                <div class="hero-body">
                    <v-card elevation="0" color="transparent">
                        <div class="logo">
                          <v-img contain src="@/assets/logo_white.png"></v-img>
                        </div>
                        <h1>WILD CEYLON ADVENTURES</h1>
                        <span class="white--text">
                          Kerris Wild, Relish Wild, Cherish Wild...
                        </span>
                    </v-card>
                    <ConfigBar/>
                </div>
              </v-col>
            </v-row>
            
          </v-container>
    </div>



    <v-row class="mt-16" no-gutters justify="center">
      <v-card elevation="0" color="transparent">
        <v-row justify="center" no-gutters>
          <v-col cols="12" xl="8" lg="8" md="10">
            <h1 class="title-font">Wild Life Sri Lanka</h1>
            <p class="text-center">
              Sri Lanka has been rated recently as a number one tourist destination in the world by several leading travel organizations. Yala along with other Wildlife Sanctuaries have been identified as leading tourist attractions around the globe. Millions of wildlife enthusiasts visit these sanctuaries every year. Home to a vast variety of endemic species, flora and fauna, the natural beauty of Sri Lanka is astounding. Ranging from Majestic Elephants to Regal Leopards to Sloth Bears and rainbow of birds & butterflies, the wildlife in and around the shores of Sri Lanka is diverse and abundant. These sanctuaries allow you to observe and reserve Wild Sri Lanka in its natural habitat.
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-row>

    <v-row no-gutters justify="center" class="mt-12">
        <ParkCard class="ma-2" :title="park.title" :text="park.text" :img="park.img" :key="i" v-for="(park,i) in ParkCardsList"/>
    </v-row>

    <v-row justify="center" class="mt-16" no-gutters>
      <v-col cols="12">
        <div class="who-we-are">
            <v-row no-gutters justify="center">
              <v-col cols="12" xl="6" lg="8" md="10">
                <h1 class="title-font white--text">Who We Are</h1>
                <p class="text-center white--text ml-8 mr-8 mt-4 TwoThirdPara">
                  We are a team of wildlife lovers dedicated to promoting wildlife tourism in Sri Lanka. We have identified the shortcomings faced by the visitors to Wildlife Parks today. Major inadequacies identified are food, comfort accommodation, convenient travelling, logistics and other important necessities. We propose a novel business concept of developing facilities with above conveniences to cater to the local and foreign visitors. We intend to develop as a consummate identity in the Sri Lankan Wildlife industry.
                </p>
              </v-col>
            </v-row>
        </div>
      </v-col>
    </v-row>

    <v-row class="mt-16" no-gutters justify="center">
      <v-card elevation="0" color="transparent">
        <v-row justify="center" no-gutters>
          <h1 class="title-font">Our Services</h1>
        </v-row>
        <p class="text-center mt-2">
          We can help you to arrange your stay and experience the wildlife within your allotted budget.
        </p>
      </v-card>
    </v-row>

    <v-row no-gutters class="pt-4 pb-4 mb-16" justify="center">
      <v-card class="ma-2" v-for="(service,i) in ServicesCardList" :key="i"  width="220" height="220">
        <v-row justify="start" class="pa-8" no-gutters>
          <v-col cols="auto">
            <v-img height="48" width="78" contain :src="service.img"></v-img>
          </v-col>
          <span class="mt-2 text-start font-weight-black FontGreyBlue">{{ service.title }}</span>
        </v-row>
      </v-card>
    </v-row>

    <v-row no-gutters>
      <v-col  cols="6" class="hidden-md-and-down color-overlay">
        <v-img width="100%" height="100%" class="opacity" src="/assets/safari2.jpg"></v-img>
      </v-col>
      <v-col cols="12" lg="6" xl="6" md="12" sm="12" class="pl-16 pr-16 GradientX">
        <v-card elevation="0" class="GradientX" dark>
          <v-card-title class="title-font white--text mb-0 mt-8">
            <v-row justify="center" no-gutters>
              <h1 class="title-font white--text">Inquiries</h1> 
            </v-row>
          </v-card-title>
          <span class="text-center">
            We look forward to hearing from you to cater to your needs.
          </span>
          <ContactForm class="mt-8 mb-8"/>
        </v-card>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import ParkCard from "@/components/ParkCard";
import ConfigBar from "@/components/ConfigBar";
import ContactForm from "@/components/ContactForm";

export default {
  name: "Home",
  components: {ContactForm, ConfigBar, ParkCard},
  data:()=>({
    ParkCardsList:[
      {
        title:'Yala National Park',
        text:'Situated in Sri Lanka’s south-east hugging the panoramic Indian Ocean, Yala was designated a wildlife sanctuary in 1900 and was designated a national park in 1938',
        img:'/assets/home_3.jpg'
      },
      {
        title:'Wilpaththu National Park',
        text:'Wilpattu National Park (Willu-pattu, "Land of Lakes") is a national park in Sri Lanka. The unique feature of this park is the existence of "Willus"',
        img:'/assets/home_2.jpg'
      },
      {
        title:'Minneriya National Park',
        text:'Minneriya National Park is a national park in North Central Province of Sri Lanka. The area was designated as a national park on 12 August 1997',
        img:'/assets/home_1.jpg'
      }
    ],
    ServicesCardList:[
      { title:'Wildlife park tours in safari jeeps ensuring safe rides', img:'/assets/home_icons/jeep.svg'},
      { title:'Meal arrangements including snacks and beverages', img:'/assets/home_icons/plate.svg'},
      { title:'Personal butler service throughout the tour ',img: '/assets/home_icons/butler.svg'},
      { title:'Closest accommodation at your convenience', img:'/assets/home_icons/bed.svg'},
      { title:'All the rental needs', img:'/assets/home_icons/camera.svg'},
    ],
    CurrentIndex:0,
    BackgroundImages:[
      '/assets/slide_show/1.jpg',
      '/assets/slide_show/2.jpg',
      '/assets/slide_show/3.jpg',
      '/assets/slide_show/4.jpg',
      '/assets/slide_show/5.jpg',
    ],
  }),
  methods:{
    ImageSlider(){
      if(this.$route.path === '/'){
        this.$refs.HeadSection.style.background = `url(${this.BackgroundImages[this.CurrentIndex]})  rgba(0, 0,0, 0.2) no-repeat center`;
        if( this.CurrentIndex === this.BackgroundImages.length - 1 ) {
          this.CurrentIndex = 0;
        } else {
          this.CurrentIndex++;
        }
      }
    }
  },
  mounted() {
    window.setInterval(() => {
      this.ImageSlider();
    }, 5000);

  }
}
</script>

<style scoped>
.PatuaFont{
  font-family: 'Patua One',serif !important;
  color: #D6AF44 !important;
}

.GradientX{
  background: transparent linear-gradient(127deg, #07614D 0%, #07614D 100%) 0 0 no-repeat padding-box;
}

.PatuaFontClean{
  font-family: 'Patua One',serif !important;
}

.primary-font {
    font-family: 'Poppins', sans-serif;
}

.GreyBlue{
  background-color: #132833 !important;
}

.FontGreyBlue{
  color: #1A4F57;
}

.HeadSection{
  width: 100%;
  height: calc(100vh - 180px);
  -webkit-border-radius: 0 0 180px 0;
  -moz-border-radius: 0 0 180px 0;
  border-radius: 0 0 180px 0;
  border: none;
  background-size: cover !important;
  background: url('/assets/slide_show/1.jpg') no-repeat center;
  box-shadow: inset 0 0 0 2000px rgb(7 97 77 / 35%);
  background-blend-mode: multiply;
  transition: 3s;
  position: relative;
}

</style>
